import { stubForType } from '../../../config/packageStubs';
import { layoutDag, shouldLayoutTopDown } from '../utils/layoutDag';

const transformPackagesToNodes = (packages, connections) => {
  if (!packages || packages.length === 0) return { nodes: [], edges: [] };

  const vertical = shouldLayoutTopDown(packages);
  const positions = layoutDag(packages, connections, { vertical });

  const nodes = [];
  for (const pkg of packages) {
    const stub = stubForType(pkg.type);
    const position = positions.get(pkg.id) || { x: 48, y: 48 };
    nodes.push({
      id: pkg.id,
      type: 'custom',
      position,
      deletable: false,
      data: {
        id: pkg.id,
        label: pkg.name || '',
        type: pkg.type || '',
        inputs: stub?.inputs || pkg.inputs || {},
        // we don't want outputs in the UI. just the names of them
        outputs: stub?.outputs || pkg.outputs || {},
        parameters: stub?.parameters || pkg.parameters || {},
        parameter_data: pkg.parameter_data || {},
        deploy_status: pkg.deploy_status || 'NOT_DEPLOYED',
        deploy_requested_at: pkg.deploy_requested_at || null,
        output_data: pkg.output_data || {},
        flowVertical: vertical,
      },
    });
  }

  // Prefer API connections (with handles + artifact $ref types) over bare DAG links.
  const edges = (connections || []).map((conn) => {
    const sourcePkg = packages.find((p) => p.id === conn.source_package_id);
    const targetPkg = packages.find((p) => p.id === conn.target_package_id);
    const sourceHandle = conn.source_handle || 'network';
    const targetHandle = conn.target_handle || sourceHandle;
    const sourceSchema =
      stubForType(sourcePkg?.type)?.outputs?.properties?.[sourceHandle] ||
      sourcePkg?.outputs?.properties?.[sourceHandle] ||
      null;
    const connectionType =
      (sourceSchema && (sourceSchema.$ref || sourceSchema.type)) ||
      sourceHandle;
    return {
      id: conn.id || `${conn.source_package_id}-${conn.target_package_id}`,
      source: conn.source_package_id,
      target: conn.target_package_id,
      sourceHandle,
      targetHandle,
      type: 'custom',
      data: {
        connectionType,
        targetDeployStatus: targetPkg?.deploy_status || 'NOT_DEPLOYED',
      },
    };
  });

  return { nodes, edges };
};

export default transformPackagesToNodes;
